import { useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getBankPaymentList = async ({
  companyCode,
  locationCode,
  month,
  year,
  departmentCode,
}) => {
  if (companyCode && locationCode) {
    let queryString = `?CompanyCode=${companyCode}&Month=${month}&Year=${year}&LocationCode=${locationCode}`;
    if(departmentCode){
      queryString += `&DepartmentCode=${departmentCode}`;
    }
    const { data } = await http_payroll.get(
      `${Api_EndPoints.GetBankPaymentList}${queryString}`,
    );
    return data;
  }
  return [];
};

export const useGetBankPaymentListQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetBankPaymentList],
    queryFn: () => getBankPaymentList(input),
    refetchOnWindowFocus: false,
  });
};
